import moment from 'moment-jalaali';

import { TInsuranceCondition } from '../api';

/** Iran weekend: Thursday & Friday */
const NON_WORKING_WEEKDAYS = new Set([4, 5]);

const IRAN_UTC_OFFSET_MINUTES = 210;

/** Parse .NET TimeSpan (`HH:mm:ss` or `d.HH:mm:ss`) to total minutes */
export const parseTimeSpanToMinutes = (value: string): number => {
  const match = value.trim().match(/^(?:(\d+)\.)?(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (!match) return 0;

  const days = Number(match[1] ?? 0);
  const hours = Number(match[2]);
  const minutes = Number(match[3]);

  return days * 24 * 60 + hours * 60 + minutes;
};

export const formatTimeSpanForDisplay = (value: string): string => {
  const totalMinutes = parseTimeSpanToMinutes(value);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const raw = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

  return raw.replace(/\d/g, (digit) => '۰۱۲۳۴۵۶۷۸۹'[Number(digit)]);
};

export const getIranNow = () => moment().utcOffset(IRAN_UTC_OFFSET_MINUTES);

export const isIranNonWorkingDay = (date = getIranNow()) => NON_WORKING_WEEKDAYS.has(date.day());

export const getRelevantTradingHours = (condition: TInsuranceCondition, date = getIranNow()) => {
  if (isIranNonWorkingDay(date)) {
    return {
      openTime: condition.nonWorkingDaysOpenTime,
      closeTime: condition.nonWorkingDaysCloseTime,
    };
  }

  return {
    openTime: condition.workingDaysOpenTime,
    closeTime: condition.workingDaysCloseTime,
  };
};

export const isWithinTradingHours = (condition: TInsuranceCondition, date = getIranNow()) => {
  const { openTime, closeTime } = getRelevantTradingHours(condition, date);
  const currentMinutes = date.hours() * 60 + date.minutes();
  const openMinutes = parseTimeSpanToMinutes(openTime);
  const closeMinutes = parseTimeSpanToMinutes(closeTime);

  return currentMinutes >= openMinutes && currentMinutes < closeMinutes;
};
